// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { getIn, useFormikContext } from 'formik';
import { isEqual } from 'lodash';

import { CREDITS_AND_BURSTS_CONFIG_ARRAY_CONFIG } from '../../configuration/credits-and-bursts';
import {
  FieldArrayGridConfigItemContext,
  FieldArrayGridUpdateButton,
  getFieldName,
} from '../../formik-utils/FieldArrayGrid';
import {
  useCreateCreditsAndBurstsConfigurationMutation,
  useUpdateCreditsAndBurstsConfigurationMutation,
} from '../../service-definitions/estimates';
import {
  CREDITS_AND_BURSTS_CREDITS_AMOUNT_BACKEND_NAME,
  DEFAULT_VALUE_FOR_DB_ROW_ID,
  ROW_ID,
} from '../../constants';
import { EstimateContext } from '../../contexts/EstimateContext';
import { CNBC_EDIT_CONFIRMATION_MODAL_CONFIG } from '../common/sgcnbc/constants';

import { getIfCNBCRowIsSG } from './utils';

export const UpdateButtonContainer = () => {
  const { estimateId } = useParams();
  const { rowValues, index, pathToFollowInValues } = useContext(FieldArrayGridConfigItemContext);
  const estimate = useContext(EstimateContext);
  const { values, initialValues } = useFormikContext();

  const [updateCNBCConfig] = useUpdateCreditsAndBurstsConfigurationMutation();
  const [createCNBCConfig] = useCreateCreditsAndBurstsConfigurationMutation();

  const isSystemGenerated = getIfCNBCRowIsSG(rowValues);

  // Check if credits have changed (similar to MLD pattern)
  const creditsFieldName = getFieldName(
    pathToFollowInValues,
    index,
    CREDITS_AND_BURSTS_CREDITS_AMOUNT_BACKEND_NAME
  );
  const currentCreditsValue = getIn(values, creditsFieldName);
  const initialCreditsValue = getIn(initialValues, creditsFieldName);
  const hasCreditsChanged = !isEqual(currentCreditsValue, initialCreditsValue);

  // Show confirmation modal only if row is system generated AND credits have changed
  const shouldShowConfirmationModal = isSystemGenerated && hasCreditsChanged;

  // Note: Update does not need the FE ID which is -1
  const rowValuesCopied = { ...rowValues };
  delete rowValuesCopied.id;

  const updateFuncParams = {
    estimateId: estimateId,
    payload: {
      ...rowValuesCopied,
      estimate_version: estimate?.inputs?.estimate_version,
    },
    cnbcRowId: rowValues[ROW_ID],
  };

  return (
    <FieldArrayGridUpdateButton
      columnsConfig={CREDITS_AND_BURSTS_CONFIG_ARRAY_CONFIG}
      confirmationModalConfig={CNBC_EDIT_CONFIRMATION_MODAL_CONFIG}
      errorMessage="There was an error in updating the Credits and Bursts configuration, please contact #cloud-commitment-estimator channel!"
      showConfirmationModal={shouldShowConfirmationModal}
      updateFunc={
        rowValues[ROW_ID] === DEFAULT_VALUE_FOR_DB_ROW_ID ? createCNBCConfig : updateCNBCConfig
      }
      updateFuncParams={updateFuncParams}
    />
  );
};
